export const selectGiftingData = ({gifting}) => ({
  url: gifting?.url || 'https://www.amazon.com/?tag=web-tracking-20',
  iconUrl:
    gifting?.iconUrl ||
    'https://g0.evitecdn.com/apps/logos/third-party/amazon_logo_plain_large.png',
  vendorName: gifting?.vendorName || 'Amazon',
});
